import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activities-page',
  templateUrl: './activities-page.component.html',
  styleUrls: ['./activities-page.component.scss']
})
export class ActivitiesPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
